module.exports = __webpack_public_path__ + "static/img/manjian.66dd0f21.png";